export const localizeSchool = (school, locale) => {
    const pickField = (field) =>
        field && typeof field === 'object' ? (field[locale] || field.en || '') : (field || '');
    return {
        ...school,
        name: pickField(school.name),
        description: pickField(school.description),
    };
};
